module.exports = __webpack_public_path__ + "static/media/PLATFORM UPGRADE A.1d70ab54.jpg";